<div class="video-modal">
    <iframe class="mfp-iframe" [src]="youtubeUrl+VideoUrl + '?autoplay=1' | safe: 'resourceUrl'" frameBorder="0" allowFullScreen=""
    allow="autoplay"   title="youtube"></iframe>
    <button type="button" class="close" (click)="closeModal()" autofocus=false><span><mat-icon>close</mat-icon></span></button>
</div>